export const DEFAULT_POPUP_TYPES = [
  {
    name: 'Headline',
    label: 'Headline',
    description: 'Popup displayed at the top of the page',
    locked: true
  },
  {
    name: 'Center',
    label: 'Center',
    description: 'Popup displayed in the center of the page',
    locked: true
  },
  {
    name: 'Bottom',
    label: 'Bottom',
    description: 'Popup displayed at the bottom of the page',
    locked: true
  }
];
